// Vue factuelle des ressentis recus dans le SaaS professionnel.
//
// Ce composant ne calcule aucun seuil, ne qualifie aucune tendance et ne
// propose aucune decision clinique. Anissa relit les donnees source dans le
// tiroir Signes vitaux et reste la seule personne qui les interprete.

export default function ClinicalAlertBanner({ feedbacks, syncError = false }) {
  if (syncError) {
    return (
      <div style={containerStyle} role="status">
        <span style={eyebrowStyle}>Ressentis</span>
        <p style={messageStyle}>
          Synchronisation indisponible. Aucun constat n'est affiche tant que
          les ressentis de l'application cliente ne sont pas charges.
        </p>
      </div>
    );
  }

  const count = Array.isArray(feedbacks) ? feedbacks.length : 0;
  if (count === 0) return null;

  return (
    <div style={containerStyle} role="status">
      <span style={eyebrowStyle}>Ressentis a relire</span>
      <p style={messageStyle}>
        {count} retour{count > 1 ? 's' : ''} recu{count > 1 ? 's' : ''}.
        {' '}Aucune interpretation automatique. Ouvrir « Signes vitaux » pour
        consulter les donnees et noter la decision d'Anissa.
      </p>
    </div>
  );
}

const containerStyle = {
  background: 'var(--jrn-surface, #FAF9F6)',
  border: '1px solid rgba(26, 46, 31, 0.10)',
  borderRadius: 12,
  padding: '14px 16px',
  marginBottom: 16,
  boxShadow: '0 1px 2px rgba(26, 46, 31, 0.04)',
};

const eyebrowStyle = {
  display: 'block',
  fontFamily: 'var(--jrn-font-ui, system-ui)',
  fontSize: 10.5,
  fontWeight: 700,
  letterSpacing: '0.12em',
  textTransform: 'uppercase',
  color: 'var(--jrn-text-muted, #6b6f6b)',
  marginBottom: 6,
};

const messageStyle = {
  margin: 0,
  color: 'var(--jrn-text-soft, #4f574f)',
  fontSize: 12.5,
  lineHeight: 1.5,
};
